import ZoomMtgEmbedded from "@zoom/meetingsdk/dist/zoomus-websdk-embedded.umd.min.js";

export default ZoomMtgEmbedded;
